export default "__VITE_ASSET__B_g8GrD$__"